import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { UserManagementService } from 'src/app/Service/user-management.service';

@Component({
  selector: 'app-user-profile',
  templateUrl: './user-profile.component.html',
  styleUrls: ['./user-profile.component.scss'],
})
export class UserProfileComponent implements OnInit {
  food: string;
  datashowtrader = false;
  datashowfarmer = false;
  documentStatus;
  customerid;
  avtar = false;
  userdata;
  companyname;
  mandi;
  personName;
  phoneNo;
  role;
  states;
  district;
  taluk;
  numberOfTrees;
  treeType;
  resultdata;
  commTradeInterest;
  reqFrequency;
  aboutUs;
  profile_Image;
  address;
  email;
  village;
  datashow = true;
  Viewprofile = false;

  harvest: any;
  cropName: any;
  unitName: any;

  constructor(
    public dialogRef: MatDialogRef<UserProfileComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    public _userService: UserManagementService
  ) {}

  ngOnInit(): void {
    var postdata = {
      userId: this.data.name,
    };
    /*Get user profile model data */
    this._userService.getuserprofile(postdata).subscribe((data) => {
      this.userdata = data;
      this.resultdata = this.userdata.result.data;
      this.datashowtrader = false;
      this.datashow = false;
      this.datashowfarmer = true;
      this.avtar = false;
      this.Viewprofile = true;
      if (this.resultdata.role == 'TRADER') {
        this.datashowtrader = true;
        this.datashowfarmer = false;
      }
      if (this.resultdata.profileImage == null) {
        this.avtar = true;
      }
      this.companyname = this.resultdata.company;
      this.documentStatus = this.resultdata.documentStatus;
      this.mandi = this.resultdata.mandi;
      this.personName = this.resultdata.personName;
      this.phoneNo = this.resultdata.phoneNo;
      this.role = this.resultdata.role;
      this.states = this.resultdata.states;
      this.district = this.resultdata.district;
      this.taluk = this.resultdata.taluk;
      this.numberOfTrees = this.resultdata.numberOfTrees;
      this.treeType = this.resultdata.treeType;
      this.commTradeInterest = this.resultdata.commTradeInterest;
      this.reqFrequency = this.resultdata.reqFrequency;
      this.aboutUs = this.resultdata.aboutUs;
      this.profile_Image = this.resultdata.profileImage;
      this.address = this.resultdata.address;
      this.documentStatus = this.resultdata.documentStatus;
      this.email = this.resultdata.companyEmail;
      this.customerid = this.resultdata.customerID;
      this.village = this.resultdata.village;
      this.harvest = this.resultdata.harvest;
      this.unitName = this.resultdata.unitName;
      this.cropName = this.resultdata.cropName;
    });
    /*Get user profile model data */
  }
  onNoClick(): void {
    this.dialogRef.close({
      // food: this.food
    });
  }
}
